module.exports = __webpack_public_path__ + "img/enquiry-fab-zh-HK.df32e64.svg";